export const UserStatuses = {
  PREBOARDING: 'preboarding',
  ONBOARDING: 'onboarding',
  ENROLLED: 'enrolled',
} as const;

export type UserStatus = (typeof UserStatuses)[keyof typeof UserStatuses];

export const USER_STATUSES_LIST: UserStatus[] = [
  UserStatuses.PREBOARDING,
  UserStatuses.ONBOARDING,
  UserStatuses.ENROLLED,
];
